import { Button, Space } from 'antd'
import { QuillEditor } from '../Editor/QuillEditor'
import { useEffect, useRef } from 'react'

export const EditableTextArea = ({
  isEditing,
  setIsEditing,
  value,
  onChange,
  placeholder,
  showSaveButton = false,
  onSave,
  onCancel
}: {
  isEditing: boolean
  setIsEditing: (isEditing: boolean) => void
  value: string
  onChange: (value: string) => void
  placeholder?: string
  showSaveButton?: boolean
  onSave?: () => void
  onCancel?: () => void
}) => {
  const editorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        editorRef.current &&
        !editorRef.current.contains(event.target as Node)
      ) {
        if (!showSaveButton) {
          setIsEditing(false)
        }
      }
    }

    if (isEditing) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isEditing, setIsEditing, showSaveButton])

  if (isEditing) {
    return (
      <div ref={editorRef}>
        <QuillEditor value={value} onChange={onChange} />
        {showSaveButton && (
          <div className="mt-2 flex justify-end">
            <Space>
              <Button 
                size="small" 
                onClick={() => {
                  onCancel?.()
                  setIsEditing(false)
                }}
              >
                Cancel
              </Button>
              <Button 
                type="primary" 
                size="small" 
                onClick={() => {
                  onSave?.()
                  setIsEditing(false)
                }}
              >
                Save
              </Button>
            </Space>
          </div>
        )}
      </div>
    )
  }
  return (
    <Button
      onFocus={() => setIsEditing(true)}
      type="text"
      className={`w-full h-auto min-h-[40px] hover:bg-gray-50 flex justify-start items-center p-0`}
      onClick={() => setIsEditing(true)}
    >
      {value ? (
        <div
          className="ql-editor prose max-w-none text-gray-600"
          dangerouslySetInnerHTML={{ __html: value }}
        />
      ) : (
        <span className="text-gray-400 px-2">
          {placeholder ?? 'Click to add text'}
        </span>
      )}
    </Button>
  )
}
